import refs from '../helpers/refs'

class CMastheadRecipeStory {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    // Print button
    this.$refs.mastheadPrint.addEventListener('click', () => {
      window.print()
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-masthead-recipe-story')
    .forEach(el => new CMastheadRecipeStory(el))
})
